import { SdeData } from "./data";
import { cr } from "fire-wind-water";

const userModel = {};
if (!userModel.modules) {
  userModel.modules = [];
}

class User {
  constructor() {
    this.instance = new SdeData();
    this.userInfo = {
      signUpStatus: 0,
    };
    this.isMember = false;
    this.isCanRegister = false;
    window.$sk.template.module(this);
  }

  module(o) {
    const key = `sk_temp_seminar_user_${new Date().getTime()}`;
    userModel.modules.push({
      key,
      model: o,
    });
    this.isUserLoad(o);
    return {
      unsubscribe() {
        userModel.modules = userModel.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  skSeminarUserEnd(data) {
    cr.each(userModel.modules, (d) => {
      if (d.model.skSeminarUserEnd) {
        d.model.skSeminarUserEnd(data);
      }
    });
  }

  skUserEnd() {
    this.getInfo();
    this.seminarSiteBrowse();
  }

  seminarSiteBrowse() {
    const m = window.$sk.template.get();
    const o = {
      sess: m.user.session,
      openId: m.user.openId || "",
      tenantId: m.common.tenantId,
      seminarId: m.common.objId,
    };
    this.instance.seminarSiteBrowse(o);
  }

  getCanRegister(seminar) {
    this.isCanRegister = false;
    const m = window.$sk.template.get();
    const o = {
      instanceId: m.common.instanceId,
      formId: seminar.registerFormId,
      sess: m.user.session || "",
      openId: m.user.openId || "",
    };
    if (parseInt(seminar.isOpenMember, 10) === 0 || o.sess) {
      this.instance.canRegisterNew(o).subscribe((res) => {
        const mo = {
          signUpStatus: res.statusCode || 0,
          qrCode: res.qrCode,
          signUpId: res.enteredId,
          isFrozen: res.signupDesc === "已冻结",
        };
        if (res.formData) {
          for (const item of res.formData) {
            if (item.fieldName === "email") {
              mo.email = item.value;
            }
          }
        }
        // const markCode = URLS.getURL("markCode");
        // const markType = URLS.getURL("markType");
        // const mj = {};
        // if (markCode) {
        //   mj.markCode = markCode;
        // }
        // if (markType) {
        //   mj.markType = markType;
        // }
        cr.extend(true, this.userInfo, mo, res);
        this.isCanRegister = true;
        this.isUserLoad();
      });
    } else {
      this.isCanRegister = true;
      this.isUserLoad();
    }
  }

  getInfo() {
    this.isMember = false;
    const m = window.$sk.template.get();
    if (m.user.session) {
      const o = {
        tenantId: m.common.tenantId,
        schemaId: m.common.schemaId,
        sess: m.user.session,
      };
      this.instance.getMemberInfo(o).subscribe((res) => {
        const mo = {
          name: res.name,
          headImg: res.headImgUrl,
        };
        cr.extend(true, this.userInfo, mo, res);
        this.isMember = true;
        this.isUserLoad();
      });
    } else {
      this.isMember = true;
    }
  }

  isUserLoad(o) {
    if (this.isMember && this.isCanRegister) {
      if (o) {
        if (o.skSeminarUserEnd) {
          o.skSeminarUserEnd(this.userInfo);
        }
      } else {
        this.skSeminarUserEnd(this.userInfo);
      }
    }
  }
}

if (!userModel.user) {
  userModel.user = new User();
}

export { userModel };
